<div class="agenx-card" [ngClass]="currentClasses">
  <header class="agenx-card__header">
    @if (title) {
      <h4 class="agenx-card__title"> {{ title }} </h4>
    }
    @if (button) {
      <agenx-circle-button (click)="onButtonClick()"
        [buttonCircleSrc]="icon_src"
        [buttonCircleTitle]="button" style="margin-left: 1rem;"></agenx-circle-button>
    }
    @if (line) {
      <span class="agenx-card__line"></span>
    }
    @if (show !== null) {
      <agenx-circle-button (click)="onShow()"
        [buttonCircleSrc]="icon_chevron" typeButton="blue"
        style="margin-left: 1rem;"></agenx-circle-button>
    }
  </header>
  @if (show === true || show === null) {
  <div [ngClass]="{'agenx-card__container': line}">
      <ng-content></ng-content>
    </div>
  }
</div>
